import { createFileRoute } from '@tanstack/react-router'

import { ListPageHeader } from '@/components/common/ListPageHeader'
import { GuideVideoGallery } from '@/components/retail/guide-videos/guide-video-gallery'
import { GuideVideoManager } from '@/components/retail/guide-videos/guide-video-manager'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

// Bán lẻ › Video hướng dẫn sử dụng: nhân viên xem video theo nhóm; người có
// shop_content.write thêm / sửa / sắp thứ tự / ẩn video ở tab Quản lý (video
// nằm trong Thư viện ảnh).
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/guide-videos',
)({
    component: GuideVideosPage,
})

export function GuideVideosPage() {
    const { hasPermission } = useAuth()
    const canWrite = hasPermission('shop_content.write')
    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader
                title={m.guideVideo_nav()}
                subtitle={m.guideVideo_subtitle()}
            />
            {canWrite ? (
                <Tabs defaultValue="watch">
                    <TabsList className="w-fit">
                        <TabsTrigger value="watch">
                            {m.guideVideo_tab_watch()}
                        </TabsTrigger>
                        <TabsTrigger value="manage">
                            {m.guideVideo_tab_manage()}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="watch" className="pt-2">
                        <GuideVideoGallery />
                    </TabsContent>
                    <TabsContent value="manage" className="pt-2">
                        <GuideVideoManager />
                    </TabsContent>
                </Tabs>
            ) : (
                <GuideVideoGallery />
            )}
        </div>
    )
}
